import { spinner_custom_styles_default } from "./chunk.AWJ376R6.js";
import { spinner_styles_default } from "./chunk.JLXCLATV.js";
import { LocalizeController } from "./chunk.IPGLY3H4.js";
import { component_styles_default } from "./chunk.NLYVOJGK.js";
import { SynergyElement } from "./chunk.AFZ5JDGZ.js";

// src/components/spinner/spinner.component.ts
import { html } from "lit";
var SynSpinner = /*#__PURE__*/(() => {
  let SynSpinner = class extends SynergyElement {
    constructor() {
      super(...arguments);
      this.localize = new LocalizeController(this);
    }
    render() {
      return html`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
  };
  SynSpinner.styles = [component_styles_default, spinner_styles_default, spinner_custom_styles_default];
  return SynSpinner;
})();
export { SynSpinner };
